import { render } from "./ModalInformacion.vue?vue&type=template&id=94ac6ffc"
import script from "./ModalInformacion.vue?vue&type=script&lang=js"
export * from "./ModalInformacion.vue?vue&type=script&lang=js"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__